import React, { useState, useEffect } from 'react';
import { useToasts } from 'react-toast-notifications';
import TasksPage from './components/pages/TasksPage';
import Login from './components/pages/Login';
import FullPagePreloader from './components/shared/FullPagePreloader';
import AccountWrapper from './components/shared/AccountWrapper';
import { useUser, unlockUser } from './firebase/api/user';
import UserStatistic from './components/shared/UserStatistic';
import LandingPage from './components/pages/LandingPage';
import isWeb from './utils/isWeb';
import ReadyTasks from './components/pages/TasksPage/ReadyTasks';

const App: React.FC = () => {
  const { addToast } = useToasts();
  const { user, loading } = useUser();
  const [isRegister, setIsRegister] = useState<boolean>(false);
  const [currentBoard, setCurrentBoard] = useState<string>('');
  const [currentUser, setCurrentUser] = useState<string>('');
  const [isLandingVisible, setIsLandingVisible] = useState<boolean>(isWeb && !user?.email);
  const [isPaid, setIsPaid] = useState<boolean>(false);

  useEffect(() => {
    isPaid &&
      addToast('Подписка успешно оформлена!', {
        appearance: 'success',
        autoDismiss: false,
      });
  }, [isPaid]);

  useEffect(() => {
    const pathname = window.location.pathname;
    const paidUid = pathname.replace('/', '');
    if (!!paidUid) {
      unlockUser(paidUid)
        .then((res) => {
          if (res === 'success') {
            setIsPaid(true);
            setTimeout(() => {
              setIsPaid(false);
            }, 3000);
          }
        })
        .catch((e) => console.log('error unlock'));
    }
  }, []);

  useEffect(() => {
    if (!!currentUser) {
      setCurrentBoard('');
    }
  }, [currentUser]);

  useEffect(() => {
    if (!!currentBoard) {
      setCurrentUser('');
    }
  }, [currentBoard]);

  useEffect(() => {
    if (!user.email) {
      setCurrentBoard('');
      setCurrentUser('');
      setIsRegister(false);
    }
  }, [user]);

  const Landing = () =>
    loading ? (
      <FullPagePreloader />
    ) : (
      <LandingPage
        toLogin={() => {
          setIsLandingVisible(false);
          setIsRegister(false);
        }}
        toRegister={() => {
          setIsLandingVisible(false);
          setIsRegister(true);
        }}
      />
    );

  const Default = () => {
    return loading ? (
      <FullPagePreloader />
    ) : user.email ? (
      <AccountWrapper
        email={user.email}
        currentBoard={currentBoard}
        currentUser={currentUser}
        setCurrentBoard={setCurrentBoard}
        setCurrentUser={setCurrentUser}
      >
        {!!currentBoard &&
          (currentBoard === 'ready' ? <ReadyTasks /> : <TasksPage boardId={currentBoard} />)}
        {!!currentUser && <UserStatistic currentUserId={currentUser} />}
      </AccountWrapper>
    ) : (
      <Login
        isRegister={isRegister}
        setIsRegister={setIsRegister}
        back={() => setIsLandingVisible(true)}
      />
    );
  };

  return isLandingVisible && !user?.email ? <Landing /> : <Default />;
};

export default App;
